module.exports = __webpack_public_path__ + "static/media/outgoing.52248a57.png";